import { Box } from '@factorialco/deprecated-design-system'

import { BankingCard } from 'modules/banking/lib/cards/types'

import { CardStatusTag } from '../CardStatusTag'

export const Status: React.FC<{ card: BankingCard }> = ({ card }) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <CardStatusTag card={card} showCircle={false} />
    </Box>
  )
}
